import { render, staticRenderFns } from "./DocenteCargaPosRow.vue?vue&type=template&id=cf64c8e8&"
import script from "./DocenteCargaPosRow.vue?vue&type=script&lang=js&"
export * from "./DocenteCargaPosRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports